/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState } from "react"
import { IRecord } from "../../types/schema"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { Fields, Form2 } from "@cd2/forms"

type IProject = IRecord<"projects", "name"> & { customerName: string }

export function ProjectsSelectList({
  value,
  onChange,
  disabled,
  error,
  required,
  branchId,
  isClearable,
}: {
  value?: string
  onChange(id: string, project: IProject): void
  disabled?: boolean
  error?: string
  required?: boolean
  isClearable?: boolean
  branchId?: string
}) {
  const skeem = window.skeem

  const [projects, setProjects] = useState<IProject[]>([])

  function handleChange(id: string) {
    console.log(id)
    onChange(id, projects.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    const projects = await skeem.fetch2<IProject[]>({
      model: {
        name: "projects",
        attributes: ["name", { as: "customerName", value: { path: ["customer", "name"] } }],
        sort: { by: "name", direction: "asc" },
      },
    })
    setProjects(projects)
  }, [branchId])

  if (projects.length === 0) {
    return <div>Loading</div>
  }

  const accountRefCss = css`
    font-size: 12px;
    font-weight: 600;
    color: #999;
  `

  return (
    <Fields.Select2
      label={<Form2.FieldLabel fieldName="project" label="Project" required={required} />}
      options={projects}
      onChange={value => handleChange(value?.id)}
      value={projects.find(v => v.id === value)}
      getOptionLabel={opt => opt.name}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      error={error}
      isClearable={isClearable}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const lead = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{lead?.name}</div>
              <div css={accountRefCss}>{lead?.customerName}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const lead = props.data as IProject

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{lead?.name}</div>
              <div css={accountRefCss}>{lead?.customerName}</div>
            </div>
          )
        },
      }}
    />
  )
}
